module.exports = __webpack_public_path__ + "img/9788992288187.7dd70c50.jpg";